import axios from 'axios'

export default { 
    async verifyOTP(data) {
        try
        { 
            const response = await axios.post(`Security/otp/verify`, {
                item: data
            });
            return response;
        }
        catch (error)
        {     
            console.log('verifyOTP error') 
            throw error
        }
    },
    async generateOTP(data) {
        try
        { 
            const response = await axios.post(`Security/otp/generate`, {
                item: data
            });
            return response;
        }
        catch (error)
        {     
            console.log('generateOTP error') 
            throw error
        }
    },
    async refreshToken(data) {
        try
        { 
            const response = await axios.post(`Security/refresh-token`, {
                item: data
            });
            return response;
        }
        catch (error)
        {     
            console.log('refreshToken error') 
            throw error
        }
    }
}